









































































































































































































































































































































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import Api from "@/api";
import Table from "@/components/Common/Table.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import BaseMixin from "@/mixins/BaseMixin";

import swal from "sweetalert";
import Multiselect from "vue-multiselect";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";
import { ICustomer, IPagination, ITableParams } from "@/interface";
import { AxiosResponse } from "axios";

interface IOption {
  id: number;
  name: string;
}

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    AlertBox,
    Table,
    Multiselect,
    VueSlider,
    DatePicker
  }
})
export default class CustomersOverview extends Mixins(BaseMixin) {
  public loading = false;
  public updating = false;
  private componentKey = 0;
  private customers: Array<ICustomer> = [];
  private customersLength = 0;
  private failedRequest = false;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    search: ""
  };
  private selectedCustomerId: number | null = null;
  private bookingsSinceDate: Date | null = null;
  private dateFormat = "DD.MM.YYYY";
  private extSearchSlider: any = {
    value: [0, 200],
    options: {
      dotSize: 14,
      width: "auto",
      height: 4,
      contained: false,
      direction: "ltr",
      data: null,
      dataLabel: "label",
      dataValue: "value",
      min: 0,
      max: 500,
      interval: 1,
      disabled: false,
      clickable: true,
      duration: 0.3,
      adsorb: false,
      lazy: false,
      tooltip: "none",
      tooltipPlacement: "top"
    }
  };
  private customerTypeValue: Array<IOption> = [
    //
  ];
  private customerTypeOptions: Array<IOption> = [
    { name: "Privat", id: 1 },
    { name: "Firma", id: 2 },
    { name: "Verein", id: 3 },
    { name: "Kindergarten", id: 4 },
    { name: "Schule", id: 5 },
    { name: "Hobby", id: 6 }
  ];
  private notCustomerTypeValue: Array<IOption> = [
    //
  ];
  private notCustomerTypeOptions: Array<IOption> = [
    { name: "Privat", id: 1 },
    { name: "Firma", id: 2 },
    { name: "Verein", id: 3 },
    { name: "Kindergarten", id: 4 },
    { name: "Schule", id: 5 },
    { name: "Hobby", id: 6 }
  ];
  private customerGroupValue: Array<IOption> = [
    //
  ];
  private customerGroupOptions: Array<IOption> = [
    { name: "Mitglieder", id: 1 }
  ];
  private notCustomerGroupValue: Array<IOption> = [
    //
  ];
  private notCustomerGroupOptions: Array<IOption> = [
    { name: "Mitglieder", id: 1 }
  ];

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      if (vm.$route.query.customer_deleted === "true") {
        swal("Success!", "The customer was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getCustomers(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.customer_deleted === true) {
      swal("Success!", "The customer was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.fetchParams.per_page !== null &&
      this.fetchParams.per_page !== undefined &&
      this.fetchParams.to !== null &&
      this.fetchParams.to !== undefined &&
      this.fetchParams.page !== undefined &&
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getCustomers(() => {
      //
    });
    next();
  }

  private addCustomerType(customerType: IOption): void {
    this.customerTypeValue.push(customerType);
  }

  private addNotCustomerType(notCustomerType: IOption): void {
    this.notCustomerTypeValue.push(notCustomerType);
  }

  private addCustomerGroup(customerGroup: IOption): void {
    this.customerGroupValue.push(customerGroup);
  }

  private addNotCustomerGroup(notCustomerGroup: IOption): void {
    this.notCustomerGroupValue.push(notCustomerGroup);
  }

  private resetExtendedSearch(): void {
    this.customerTypeValue = [];
    this.notCustomerTypeValue = [];
    this.customerGroupValue = [];
    this.notCustomerGroupValue = [];
    this.extSearchSlider.value = [0, 200];
    this.bookingsSinceDate = null;
  }

  private getCustomers(successCallback?: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.customers = [];
    const endpoint = this.$partnerEndpoint("customers");

    Api()
      .get(endpoint, {
        params: {
          page: this.fetchParams.page,
          search: this.fetchParams.search
        }
      })
      .then((response: AxiosResponse) => {
        this.customers = response.data.data;
        this.metaData = response.data.meta;
        this.customersLength = response.data.data.length;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }
}
